export default {
  windowList: {
    items: [],
    total: 0,
  },
  loading: false,
  windowDetails: {},
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-capacity-management/features/window/store/state.js